import React, { useState } from 'react';
import cx from 'classnames';

import { DefaultFilledButton } from '@magoosh/lib/button';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

import * as api from '@payments/api';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from '@payments/style.module.scss';

interface Props {
  couponCode: string;
  onApply: (couponCode: string, discount: any) => void;
  subscriptionPlanId: number;
}

const CouponCodeInput: React.FC<Props> = (props) => {
  const [error, setError] = useState(null);
  const [isApplying, setIsApplying] = useState(false);
  const [localCouponCode, setLocalCouponCode] = useState(props.couponCode);

  const isApplied = props.couponCode && props.couponCode === localCouponCode;

  const applyCoupon = async () => {
    if (props.couponCode === localCouponCode) return;

    setIsApplying(true);

    try {
      const response = await api.validateCoupon(props.subscriptionPlanId, localCouponCode);

      setError(null);
      setIsApplying(false);

      props.onApply(localCouponCode, response);
    } catch(exception) {
      setError(exception.message);
      setIsApplying(false);
    }
  };

  const applyOnEnter = (e) => {
    setError(null);

    if (e.key === 'Enter') {
      e.preventDefault();
      applyCoupon();
      return false;
    }
  };

  return (
    <div>
      <div className={cx('form-group', { 'has-error': !!error })}>

        <label className="control-label">
          Promo Code
        </label>

        <div className="d-flex" style={{ gap: 10 }}>
          <div className={cx(style.mediumStringInput, { 'has-success': isApplied })}>
            <div className="input-group">
              <div className="input-group-addon">
                <FontAwesomeIcon icon="check" style={{ color: isApplied ? colors.brandPrimary : error ? colors.brandDanger : colors.gray85 }} />
              </div>
              <input
                className="form-control"
                name="couponCode"
                value={localCouponCode}
                onChange={(e) => setLocalCouponCode(e.target.value)}
                onKeyDown={applyOnEnter}
                onKeyUp={applyOnEnter}
              />
            </div>

            {
              error && (
                <span className="text-danger">
                  <small>{error}</small>
                </span>
              )
            }
          </div>

          <div>
            <DefaultFilledButton
              disabled={isApplied}
              onClick={applyCoupon}
              submitting={isApplying}
            >
              {isApplied ? 'Applied!' : isApplying ? 'Applying' : 'Apply'}
            </DefaultFilledButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponCodeInput;
